const user = {
  first_name: "Nombre",
  last_name: "Apellido",
  email: "Correo electrónico",
  gender: "Género",
  phone_number: "Celular",
  birthday_with_format: "Fecha de nacimiento mm/dd/aaaa",
  gender_options: {
    male: "Hombre",
    female: "Mujer",
    unspecified: "Prefiero no decir",
  },
  culture_id: "Seleccione el país de origen de su familia",
  other_culture_name: "Especificar el país de origen de su familia",
  mexico_state_id: "¿De qué estado de México proviene su familia?",
  interests: "Intereses",
  language: "Idioma",
  language_options: {
    spanish: "Español",
    english: "Inglés",
  },
  profile: {
    cancel_edit_cta: "Cancelar",
    payment_cta_title: "Facturación",
    submit_cta: "Aplicar cambios",
  },
};

export default user;
